module.exports = __webpack_public_path__ + "img/green-rounded-cross.2c147e6e.svg";